import sharedRouteNames from "@/shared/router/routeNames";

export default {
  questionnairePersonal: "questionnaire-personal",
  ...sharedRouteNames,
};
